import { FaFacebook, FaWhatsapp } from 'react-icons/fa';
import { WhatsappShareButton } from 'react-share';
import Notification, { showToast } from '../../../components/common/notification/Notification';


const ShareButtons = ({ item, shareUrl, cardImg, defaultImage }) => {
  // Log props for debugging
  console.log('ShareButtons Props:', {
    item,
    shareUrl,
    cardImg,
    defaultImage,
  });

    const postText = `🏠 ${item.title || 'Property Listing'}
📍 Location: ${item.city?.name || 'Unknown'}, ${item.state?.name || 'Unknown'}
💰 Price: ₹${item.budget || 'N/A'}
📝 Description: ${item.description || 'No description'}
🖼️ Image: ${cardImg || defaultImage || 'https://allhomedesire.com/images/logo.jpg'}

🔗 View More: ${shareUrl}
#AllHomeDesire #Property`;

  const handleShare = () => {
    showToast('Post content copied! Just paste it on Facebook.', { type: 'success' });

    navigator.clipboard.writeText(postText).then(() => {
      // Wait 2 seconds, then open Facebook share link
      setTimeout(() => {
        window.open(
          `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(shareUrl)}`,
          '_blank'
        );
      }, 3000);
    });
  };
  return (
      <div className="share-buttons d-flex flex-column">
        <Notification /> 
        
        <button
          onClick={handleShare}
          className="dropdown-item-custom no-nav d-flex align-items-center px-3 py-1"
        >
          <FaFacebook size={16} className="me-2 text-primary" />
          <span className="text-secondary">Share on Facebook</span>
        </button>

        <WhatsappShareButton
          url={`${shareUrl}\nImage: ${cardImg || defaultImage}`}
          title={`*${item.title || 'Property Listing'}*\n*Description:* ${
            item.description || 'No description'
          }\n*Price:* ${item.budget || 'N/A'}\n*Location:* ${
            item.state?.name || 'Unknown'
          }, ${item.city?.name || 'Unknown'}\n\n`}
          className="dropdown-item-custom no-nav d-flex align-items-center px-3 py-1"
          style={{ whiteSpace: 'nowrap', width: '100%' }}
        >
          <FaWhatsapp size={16} className="me-2 text-success" />
          <span className="text-secondary">Share on WhatsApp</span>
        </WhatsappShareButton>
      </div>
  );
};

export default ShareButtons;